export const SYSTEM_STATUS_API_PATH = "/api/system-status"

export const SYSTEM_STATUS_CACHE_CONTROL =
  "public, max-age=0, s-maxage=60, stale-while-revalidate=300"
